// extracted by mini-css-extract-plugin
export default {"signup":"css_signup__RaaPz","form":"css_form__Sr5Y0"};